import React from 'react'
import { Button, FormInstance, Modal } from 'antd';
import { TFunction } from 'i18next';
import classes from './LicenseTermModal.module.scss';
import PDFViewer from 'components/Webviewer/Viewer/PDFViewer';
import { BuildNames, Languages, licensesOfApp } from 'interfaces/IBuildLanguage';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';

const buildName: BuildNames | string = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' ? window.REACT_APP_BUILD_NAME : process.env.REACT_APP_BUILD_NAME || BuildNames.Tazadeal;

type LicenseTermModalProps = {
  isLicenseTermModalOpen?: boolean;
  setIsLicenseTermModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  t: TFunction;
  form: FormInstance<any>;
};

export default function LicenseTermModal(
  {
    isLicenseTermModalOpen,
    setIsLicenseTermModalOpen,
    t,
    form,
  }: LicenseTermModalProps
) {
  const [isAvailableAccept, setIsAvailableAccept] = React.useState<boolean>(false);
  const isAlreadyAccept = form.getFieldValue(['is_accepted_agreement']);

  const footerWithAcceptButton = (
    <Button
      disabled={!isAvailableAccept}
      type='primary'
      onClick={() => {
        form.setFieldsValue({ is_accepted_agreement: true });
        form.validateFields(['is_accepted_agreement']);
        setIsLicenseTermModalOpen(false);
      }}
    >
      {t('Confirm.acceptButton')}
    </Button>
  );  

  return (
    <Modal
      className={cn(classes.modalLicense, getTheme())}
      width={'90%'}
      onCancel={() => setIsLicenseTermModalOpen(false)}
      title={t('PersonalInfo.licenseTitle')}
      open={isLicenseTermModalOpen}
      centered={true}
      footer={isAlreadyAccept ? null : footerWithAcceptButton}
    >
      <div style={{height: '85vh'}}>
        <PDFViewer
          url={licensesOfApp[buildName as BuildNames][Languages.Ru]} // [i18n.language as Languages] // useTranslation()
          isModal={false}
          setIsAvailableAccept={setIsAvailableAccept}
        />
      </div>
    </Modal>
  )
}

